// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2qMzx","title":"ClientInsurance_title__2cGr5","itemText":"ClientInsurance_itemText__THe6v"};